/**
 * Low Stock Alerts Hook
 * @see Sprint 28 - US-28.4
 */

import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '../services/dashboard.service';
import { dashboardKeys } from './useDashboardData';

export function useLowStockAlerts() {
  return useQuery({
    queryKey: [...dashboardKeys.all, 'lowStockAlerts'] as const,
    queryFn: () => dashboardService.getLowStockAlerts(),
    staleTime: 2 * 60 * 1000,
    placeholderData: (prev) => prev,
  });
}
